export default __webpack_public_path__ + "static/media/login_bg_monacofit.f6f5ddfa.jpg";